<template>
    <div class="outer">
        <div class="top" :style="{width: '334px'}">
            <el-input v-model="keyword" placeholder="搜索模型名称/设备类型" size="small" @input="bounce(1)">
                <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
        </div>
        <div class="divider" :style="{marginTop: '20px'}"></div>
        <el-table :style="{width: '100%'}" :data="list">
            <el-table-column label="" show-overflow-tooltip width="62">
                <template slot-scope="scope">
                    <el-radio v-if="scope.row.serves.length"  :label="scope.row.id" v-model="current" @change="$emit('input',scope.row)">{{emptyData}}</el-radio>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="模型名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="ellipsis">{{scope.row.name || '-'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="industry" label="所属行业" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="ellipsis">{{scope.row.industry || '-'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="deviceType" label="设备类型" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="ellipsis">{{scope.row.deviceType || '-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="71">
                <template v-slot="{row}">
                    <el-button type="text" @click="read(row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="bottom">
            <el-pagination
                    class="pagination"
                    layout="prev, pager, next, jumper"
                    :page-size="pageSize"
                    :total="total"
                    :current-page="page"
                    @current-change="bounce"
            >
            </el-pagination>
        </div>
        <modal-drawer ref="modalDrawer"/>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import modalDrawer from "./modalDrawer";
    import {dealErrorCode} from "../../store/server";
    export default {
        name: "modalSelector",
        data() {
            return {
                keyword: '',
                emptyData: '',
                timer: null,
                list: [],
                page: 1,
                pageSize: 5,
                total: 0,
                current: null,
            }
        },
        props: {
            value: Object,
        },
        components: {
            modalDrawer,
        },
        watch: {
            value(v) {
                if (v) {
                    this.current = v.id;
                } else {
                    this.current = null;
                }
            }
        },
        methods: {
            ...mapActions([
                'GetModelList',
            ]),
            async getData() {
                let res = await this.GetModelList({
                    page: this.page,
                    limit: this.pageSize,
                    search: this.keyword
                });
                if (res.code === 1000) {
                    this.list = res.data;
                    this.total = res.total;
                }  else if (dealErrorCode(res.code)) {
                    this.$message.error('获取数据失败')
                }
            },
            changePage(v) {
                this.page = v;
                this.getData();
            },
            bounce(v) {
                if (this.timer !== null) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        this.changePage(v)
                    } catch (e) {
                        console.log(e)
                    } finally {
                        clearTimeout(this.timer)
                        this.timer = null
                    }
                }, 300)
            },
            read(data) {
                this.$refs.modalDrawer.show(data);
            }
        },
        mounted() {
            if (this.value) {
                this.current = this.value.id;
            } else {
                this.current = null;
            }
            this.getData();
        }
    }
</script>

<style scoped>
    .bottom{
        text-align: right;
        padding-top: 10px;
    }
    .el-table{
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
}
</style>